export const ART_URL = import.meta.env.PUBLIC_BASE_URL;
export const GlobalConfig = {
    CHANNEL_ORCHESTRATOR_ACCESS_LICENCE:["business","enterprice"]
} 